<span class="text-body2 cursor-pointer py-2 px-4 text-info-500 hover:bg-info-50 rounded-full transition-all duration-300">
  <ng-content></ng-content>
</span>
